
define('text!application/modules/reports/reports.html',[],function () { return '<!-- module header -->\r\n<div data-bind="template:secondaryHeaderContent" :class="[[currentStateIdClass]]"></div>\r\n<!-- module content -->\r\n<div id="report_wrapper" data-bind="ojModule:applicationModule" :class="[[currentStateIdClass]]"></div>';});

